import { render, staticRenderFns } from "./TarrifsPage.vue?vue&type=template&id=3b1ddb5a&scoped=true"
import script from "./TarrifsPage.vue?vue&type=script&lang=js"
export * from "./TarrifsPage.vue?vue&type=script&lang=js"
import style0 from "./TarrifsPage.vue?vue&type=style&index=0&id=3b1ddb5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ddb5a",
  null
  
)

export default component.exports